module.exports = __webpack_public_path__ + "img/en-mb-s5.d1ad4a57.png";